module.exports = __webpack_public_path__ + "static/img/ys_3.5deb8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/ys_3.png
// module id = EE0V
// module chunks = 1